module.exports = __webpack_public_path__ + "static/media/login-bg-1.6668a9f2.png";